import { getBackgroundClass, getLayoutClass } from "../../utils/sectionHelpers";
import starIcon from "../../images/star-icon.png";
import DynamicImage from "../common/DynamicImage";
import { renderText } from "../common/renderText";
import React from "react";
import { HighlightText } from "../common/HighlightText";

const ImageWithText = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  const layoutClass = getLayoutClass(settings.layout);
  return (
    <section
      className={`overview-area ptb-70 services-section ${backgroundClass}`}
    >
      <div className="container">
        {/* {data?.subtitle && (
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <div className="section-title">
                                <h2 className="highlight-text">{data?.subtitle}
                                </h2>
                            </div>
                        </div>
                    </div>
                )} */}
        <div className="row justify-content-center mb-3">
          <div className="col-lg-9" data-aos="fade-up" data-aos-duration="1200">
            <div className="content text-start text-lg-center">
              {data?.secTitle?.map((block, index) => {
                switch (block.type) {
                  case "paragraph":
                    return (
                      <p key={index} className="mb-0">
                        {block.children.map((child, i) => {
                          let textElement = child.text;

                          if (child.bold) {
                            textElement = <strong>{textElement}</strong>;
                          }

                          if (child.italic) {
                            textElement = <em>{textElement}</em>;
                          }

                          if (child.underline) {
                            textElement = <u>{textElement}</u>;
                          }

                          if (child.strikethrough) {
                            textElement = <s>{textElement}</s>;
                          }

                          return (
                            <React.Fragment key={i}>
                              {textElement}
                            </React.Fragment>
                          );
                        })}
                      </p>
                    );

                  case "heading":
                    const Tag = `h${block.level}`;
                    return (
                      <Tag key={index} className="mt-4 mb-3">
                        {/* {block.children.map((c) => c.text).join("")} */}
                        <HighlightText content={block.children.map((c) => c.text).join("")} />
                      </Tag>
                    );

                  case "list":
                    return (
                      <ul key={index} className="list-unstyled">
                        {block.children.map((item, i) => (
                          <li key={i} className="features-text">
                            <h4>
                              <i className="flaticon-tick"></i>{" "}
                              {item.children.map((c) => c.text).join("")}
                            </h4>
                          </li>
                        ))}
                      </ul>
                    );

                  default:
                    return null;
                }
              })}
            </div>
          </div>
        </div>
        <div
          className={`row align-items-center justify-content-center gy-4 gx-lg-5 ${layoutClass}`}
        >
          <div
            className="col-lg-6 col-md-12"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <div className="overview-box">
              <div className="overview-content">
                <div className="content section-title text-start">
                  {data?.subtitle && (
                    <span className="sub-title">
                      <img src={starIcon} alt="banner" />
                      {data?.subtitle}
                    </span>
                  )}
                  {data?.title && <h2><HighlightText content={data?.title} /></h2>}

                  {data?.description?.map((block, index) => {
                    switch (block.type) {
                      case "paragraph":
                        return <p key={index}>{renderText(block.children)}</p>;

                      case "heading":
                        const Tag = `h${block.level}`;
                        return (
                          <Tag key={index} className="mt-4 mb-3">
                           <HighlightText content={block.children.map((c) => c.text).join("")} />
                          </Tag>
                        );
                      case "list":
                        const ListTag =
                          block.format === "ordered" ? "ol" : "ul";

                        return (
                          <ListTag key={index} className="list-unstyled">
                            {block.children.map((item, i) => (
                              <li key={i} className="features-text">
                                <h4>
                                  <i className="flaticon-tick"></i>
                                  <span>
                                    {item.children.map((child, j) => {
                                      const isBold =
                                        child.bold ||
                                        child.marks?.some(
                                          (mark) => mark.type === "bold",
                                        );

                                      if (isBold) {
                                        return <b key={j}>{child.text}</b>;
                                      }

                                      return child.text;
                                    })}
                                  </span>
                                </h4>
                              </li>
                            ))}
                          </ListTag>
                        );

                      default:
                        return null;
                    }
                  })}
                  {data.quotes ? (
                    <div className="partner-quote">
                      {data?.quotes?.map((block, index) => {
                        switch (block.type) {
                          case "paragraph":
                            return (
                              <p key={index} className="mb-0 mt-0">
                                {renderText(block.children)}
                              </p>
                            );

                          case "heading":
                            const Tag = `h${block.level}`;
                            return (
                              <Tag key={index}>
                                <HighlightText content={block.children.map((c) => c.text).join("")} />
                              </Tag>
                            );

                          case "list":
                            const ListTag =
                              block.format === "ordered" ? "ol" : "ul";
                            return (
                              <div className="overview-box">
                                <div className="overview-content">
                                  <div className="content">
                                    <ListTag
                                      key={index}
                                      className="list-unstyled"
                                    >
                                      {block.children.map((item, i) => (
                                        <li key={i} className="features-text">
                                          <h4>
                                            <i className="flaticon-tick"></i>
                                            <span>
                                              {item.children.map((child, j) => {
                                                const isBold =
                                                  child.bold ||
                                                  child.marks?.some(
                                                    (mark) =>
                                                      mark.type === "bold",
                                                  );

                                                if (isBold) {
                                                  return (
                                                    <b key={j}>{child.text}</b>
                                                  );
                                                }

                                                return child.text;
                                              })}
                                            </span>
                                          </h4>
                                        </li>
                                      ))}
                                    </ListTag>
                                  </div>
                                </div>
                              </div>
                            );

                          default:
                            return null;
                        }
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {data?.image?.[0] && (
            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div className="overview-image text-center">
                <div className="image">
                  <DynamicImage image={data.image[0]} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default ImageWithText;
